import type { TimePeriod } from '@carboncopyco/types';
import { DropdownFilter } from '@carboncopyco/ui';
import { useDashboardAnalytics } from '@carboncopyco/utils';
import { periodOptions } from '../../Charts/consts';
import { useUrlState } from '../../utils';

export const RangeFilter = () => {
  const [urlState, setUrlState] = useUrlState({
    timeRange: '30',
  });
  const { timeRange } = urlState;
  const { trackDashboardDateFilterClick } = useDashboardAnalytics();

  return (
    <DropdownFilter<TimePeriod>
      capsuleWidth={200}
      contentWidth={200}
      selected={timeRange}
      items={periodOptions}
      onSelect={(timeRange) => {
        setUrlState({ ...urlState, timeRange });
        trackDashboardDateFilterClick({
          dashboardRangeFilter: timeRange,
        });
      }}
      placeholder=""
      sideOffset={-10}
    />
  );
};
